import type { CurrentUserProfile } from '@/types'

export type PersonaRole = 'coordinator' | 'owner' | 'client'

export interface Persona {
  id: PersonaRole
  name: string
  role: string
  roleLabel: string
  initial: string
  color: string
  activeColor: string
}

// Defaults neutros — sobrescritos pelo profile.user.name quando carregado.
// Antes tinham nomes pessoais (Sarah/Bruno) que vazavam pra outros tenants
// durante o loading do profile.
export const PERSONAS: Record<PersonaRole, Persona> = {
  coordinator: {
    id: 'coordinator', name: 'Coordenadora', role: 'coordinator', roleLabel: 'Coordenadora',
    initial: 'C', color: 'bg-persona-coord', activeColor: 'bg-persona-coord',
  },
  owner: {
    id: 'owner', name: 'Gestor', role: 'admin', roleLabel: 'Gestor',
    initial: 'G', color: 'bg-success', activeColor: 'bg-success',
  },
  client: {
    id: 'client', name: 'Cliente', role: 'client', roleLabel: 'Cliente',
    initial: 'C', color: 'bg-brand-client', activeColor: 'bg-brand-client',
  },
}

/**
 * Persona derivada do perfil real autenticado. Em auth real, o dashboard
 * precisa vir do role do profile: senão o usuário cai no dashboard errado
 * por default do localStorage. Impersonação segue o target (profile já é
 * do user impersonado); god mode cai como 'owner'.
 */
export function resolvePersonaRoleFromProfile(profile: CurrentUserProfile): PersonaRole {
  if (profile.user.user_type === 'client_user') return 'client'
  if (profile.team?.role === 'admin' || profile.team?.role === 'manager') return 'owner'
  return 'coordinator'
}
